import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShippingTransportationGroupsList } from './normalize';

export const fetchShippingTransportationGroupsList = createProvider(api.fetchShippingTransportationGroupsList)
  .andThen((res) => normalizeShippingTransportationGroupsList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
